import { useFormContext, Controller } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import MultiSelectField, {
  IMultiSelectDropdownProps,
} from 'components/controllers/multiSelectDropdown'
import { TypoGraph } from 'components'
import colors from 'theme/colors'

interface IMultiselectFormFieldProps extends IMultiSelectDropdownProps {
  name: string
  required?: boolean
}

const MultiSelectFormField: React.FC<IMultiselectFormFieldProps> = (props) => {
  const { name, required = false } = props
  const { control } = useFormContext()
  const isRequired = required ? 'Field is Required' : undefined
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired,
        validate: {},
      }}
      render={({
        field: { onChange, value },
        formState: { errors },
        fieldState: { error },
      }) => {
        return (
          <>
            <MultiSelectField
              value={value ? value : ''}
              onChange={onChange}
              errors={errors}
              error={Boolean(error)}
              required={required}
              {...props}
            />
            <ErrorMessage
              errors={errors}
              name={name ? name : ''}
              render={({ message }) => (
                <TypoGraph
                  variant="caption"
                  color={colors.error}
                  content={message}
                  sx={{
                    margin: '3px 14px 0 14px',
                  }}
                />
              )}
            />
          </>
        )
      }}
    />
  )
}

export default MultiSelectFormField
